import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MdDone, MdWarning, MdCancel, MdEmail, MdCameraAlt } from 'react-icons/md'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { CSVLink } from 'react-csv'
import Select from 'react-select'

const tbcolumn = [
  {
    label: 'Invoice No.',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Customer',
    field: 'customer',
    sort: 'asc',
  },
  {
    label: 'Invoice Date',
    field: 'invoice_date',
    sort: 'asc',
  },
  {
    label: 'Due Date',
    field: 'due_date',
    sort: 'asc',
  },
  {
    label: 'Terms',
    field: 'terms',
    sort: 'asc',
  },
  {
    label: 'Location',
    field: 'location',
    sort: 'asc',
  },
  {
    label: 'Schedule',
    field: 'schedule',
    sort: 'asc',
  },
  {
    label: 'Memo',
    field: 'memo',
    sort: 'asc',
  },
  {
    label: 'Item(Product/Service)',
    field: 'item',
    sort: 'asc',
  },
  {
    label: 'Item(Description)',
    field: 'item_description',
    sort: 'asc',
  },
  {
    label: 'Item(Quantity)',
    field: 'item_quantity',
    sort: 'asc',
  },
  {
    label: 'Item(Rate)',
    field: 'item_rate',
    sort: 'asc',
  },
  {
    label: 'Item(Amount)',
    field: 'item_amount',
    sort: 'asc',
  },
  {
    label: 'Item(TaxCode)',
    field: 'item_taxcode',
    sort: 'asc',
  },
  {
    label: 'Item(TaxAmount)',
    field: 'item_taxamount',
    sort: 'asc',
  },
  {
    label: 'Currency',
    field: 'currency',
    sort: 'asc',
  },
  {
    label: 'Service Date',
    field: 'service_date',
    sort: 'asc',
  },
]

const headers = [
  {
    label: '*Invoice No.',
    key: 'invoice_no',
  },
  {
    label: '*Customer',
    key: 'customer',
  },
  {
    label: '*Invoice Date',
    key: 'invoice_date',
  },
  {
    label: '*Due Date',
    key: 'due_date',
  },
  {
    label: 'Terms',
    key: 'terms',
  },
  {
    label: 'Location',
    key: 'location',
  },
  {
    label: 'Schedule',
    key: 'schedule',
  },
  {
    label: 'Memo',
    key: 'memo',
  },
  {
    label: 'Item(Product/Service)',
    key: 'item',
  },
  {
    label: 'Item(Description)',
    key: 'item_description',
  },
  {
    label: 'Item(Quantity)',
    key: 'item_quantity',
  },
  {
    label: 'Item(Rate)',
    key: 'item_rate',
  },
  {
    label: '*Item(Amount)',
    key: 'item_amount',
  },
  {
    label: '*Item(TaxCode)',
    key: 'item_taxcode',
  },
  {
    label: 'Item(TaxAmount)',
    key: 'item_taxamount',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Service Date',
    key: 'service_date',
  },
]

class SupplierReport extends React.Component {
  _isMounted = true
  SupplierReport = StorageService.getSession('SupplierReport')
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    this.state = {
      //isLoading: true,
      filterList: [],
      // date:
      //   this.orderDetail && this.orderDetail.date
      //     ? this.orderDetail.date
      //     : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      fm_date: this.SupplierReport && this.SupplierReport.fm_date ? this.SupplierReport.fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date: this.SupplierReport && this.SupplierReport.to_date ? this.SupplierReport.to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),

      p_fm_date: this.SupplierReport && this.SupplierReport.p_fm_date ? this.SupplierReport.p_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      p_to_date: this.SupplierReport && this.SupplierReport.p_to_date ? this.SupplierReport.p_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_fm_date: this.SupplierReport && this.SupplierReport.f_fm_date ? this.SupplierReport.f_fm_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_to_date: this.SupplierReport && this.SupplierReport.f_to_date ? this.SupplierReport.f_to_date : moment().add(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      csvInvoice: [],
      csvPrepaid: [],
      csvFOC: [],
      storeList: [],
      store_id: this.SupplierReport && this.SupplierReport.store_id ? this.SupplierReport.store_id : this.props.data.storeList[0].store_id,
      p_store_id: this.SupplierReport && this.SupplierReport.p_store_id ? this.SupplierReport.p_store_id : this.props.data.storeList[0].store_id,
      supplierList: [],
      supplier_id: this.SupplierReport && this.SupplierReport.supplier_id ? this.SupplierReport.supplier_id : 'All',
      p_supplier_id: this.SupplierReport && this.SupplierReport.p_supplier_id ? this.SupplierReport.p_supplier_id : '',
      Role: this.comp.Role,
      consolidate: this.SupplierReport && this.SupplierReport.consolidate ? this.SupplierReport.consolidate : 0,
      headers: [],
    }

    this.csvLinkEl = React.createRef()
    this.csvLinkEl2 = React.createRef()
    this.csvLinkEl3 = React.createRef()
  }

  componentDidMount() {
    //this.getOrder();
    // this.CsvInvoice();
    // this.CsvPrepaid();
    // this.CsvFOC();
    this.getStoreList()
    this.getSupplier()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getStoreList() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const access = StorageService.getSession('user_access')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/store', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          let storeList = []
          for (let i of access.store) {
            for (let j of result.data) {
              if (j.store_id === i.store_id) {
                if (i.role == 'Admin' || i.role == 'Supervisor' || i.role == 'Financial' || i.role == 'Manager' || i.role == 'Superuser') {
                  storeList.push(j)
                }
              }
            }
          }
          this.setState({
            storeList: storeList,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getSupplier = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3002/v1/product/supplier', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            supplierList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    let data = this.SupplierReport ? this.SupplierReport : {}
    data[name] = value
    StorageService.setSession('SupplierReport', data)
    this.SupplierReport = StorageService.getSession('SupplierReport')
  }

  storeHandler = e => {
    const { label, value } = e
    this.setState({
      store_id: value,
    })
    let data = this.SupplierReport ? this.SupplierReport : {}
    data['store_id'] = value
    StorageService.setSession('SupplierReport', data)
    this.SupplierReport = StorageService.getSession('SupplierReport')
  }

  p_storeHandler = e => {
    const { label, value } = e
    this.setState({
      p_store_id: value,
    })
    let data = this.SupplierReport ? this.SupplierReport : {}
    data['p_store_id'] = value
    StorageService.setSession('SupplierReport', data)
    this.SupplierReport = StorageService.getSession('SupplierReport')
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.SupplierReport ? this.SupplierReport : {}
    data[name] = value
    StorageService.setSession('SupplierReport', data)
    //this.getOrder(value)
  }

  searchHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.SupplierReport ? this.SupplierReport : {}
    data[name] = value
    StorageService.setSession('SupplierReport', data)
    this.SupplierReport = StorageService.getSession('SupplierReport')

    if (name === 'fm_date') {
      this.setState({
        to_date: value,
      })
      let data = this.SupplierReport ? this.SupplierReport : {}
      data['to_date'] = value
      StorageService.setSession('SupplierReport', data)
      this.SupplierReport = StorageService.getSession('SupplierReport')
    }

    if (name === 'p_fm_date') {
      this.setState({
        p_to_date: value,
      })
      let data = this.SupplierReport ? this.SupplierReport : {}
      data['p_to_date'] = value
      StorageService.setSession('SupplierReport', data)
      this.SupplierReport = StorageService.getSession('SupplierReport')
    }
  }

  CsvInvoice = async (name, value) => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let fm_date = name === 'fm_date' ? value : this.state.fm_date
    let to_date = name === 'to_date' ? value : this.state.to_date
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      //store_id: '271',
      fm_date: fm_date,
      to_date: to_date,
      supplier_id: this.state.supplier_id,
      consolidate: this.state.consolidate,
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date).tz('Asia/Singapore').format('DD/MM/YYYY')
            }
          }

          if (result.data.length > 0) {
            let headers = [
              ...Object.keys(result.data[0])
                .reduce((r, o) => {
                  console.log(o)
                  let key = o
                  let item = { key: o, label: o }
                  return r.set(key, item)
                }, new Map())
                .values(),
            ]

            this.setState(
              {
                csvInvoice: result.data,
                isLoading: false,
                headers: headers,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl.current.link.click()
                })
              },
            )
          } else {
            this.CsvNotFound('No Orders for Supplier')
          }
        }
      })
      .catch(error => {
        alert(error)
        this.setState({
          isLoading: false,
        })
      })
  }

  CsvPrepaid = event => {
    event.preventDefault()
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let fm_date = this.state.p_fm_date
    let to_date = this.state.p_to_date
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.p_store_id,
      //store_id: 271,
      fm_date: fm_date,
      to_date: to_date,
      supplier_id: this.state.p_supplier_id,
      //supplier_id: 'ygZWhhMmvrI4vVA7zyHI',
    }

    axios
      .post(url + ':3003/v1/order/export/custom/jb/pdf', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          window.open(`https://unityapi2.pseudoscops.com/topdfso.php?d=${result.data}`, '_blank')
          this.setState({ isLoading: false })
        }
      })
      .catch(error => {
        alert(error)
        this.setState({
          isLoading: false,
        })
      })
  }

  CsvNotFound(message) {
    this.setState({ isLoading: false })
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: message,
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  render() {
    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    }

    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Supplier Order (CSV)</p>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <Label>Store</Label>
              <Select options={options} value={options.filter(i => i.value == this.state.store_id)} name="store_id" onChange={this.storeHandler} menuPosition={'fixed'} required />
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="fm_date" value={this.state.fm_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Label></Label>
              <p
                style={{
                  padding: '0.4rem',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}>
                To
              </p>
            </Col>
            <Col md={2}>
              <FormGroup>
                <Label>Fulfilment Date</Label>
                <Input className="ps-input-small" type="date" name="to_date" value={this.state.to_date} onChange={this.searchHandler} disabled={this.state.isLoading} required />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Label>Supplier</Label>
              <Input className="ps-input-small" type="select" name="supplier_id" value={this.state.supplier_id} onChange={this.changeHandler}>
                <option value="All">All</option>
                {this.state.supplierList.map(item => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  )
                })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Consolidate</Label>
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" name="consolidate" checked={this.state.consolidate} onChange={this.checkHandler} />
                </Label>
              </FormGroup>
            </Col>
            <Col
              md={1}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}>
              <Button type="button" className="ps-input-small theme-button-primary" disabled={this.state.isLoading} onClick={this.CsvInvoice}>
                Export
              </Button>
              <CSVLink headers={this.state.headers} filename={'invoice_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'} data={this.state.csvInvoice} ref={this.csvLinkEl} />
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default SupplierReport
